module.exports = __webpack_public_path__ + "media/images/ui__textArrowUpLight-a9b16e17c6387dc45387a27beaf05c4a.png";